<template>
<div class="downloadLoadingWrapper">
<div class="downloadLoading">
    <div class="downloadLoadingWrapper">
        <div class="downloadimgWrapper">
        <img src='../../assets/load.gif' class="downloadImg" />
        </div>
        <div class="subSucess">
            提交成功
        </div>
        <div class="sysValuting">
            系统正在估值，请稍候～
        </div>
        <div class="dataSerching">
            {{flowTitle}}
        </div>
    </div>
</div>
</div>
</template>

<script>
export default {
  name: 'reportLoading',
  data() {
    return {
      textflag: [
        '系统正在估值',
        '工商数据查询中···',
        '行业数据查询中···',
        '宏观经济数据查询中···',
        '市场一致预期数据查询中···',
        '对标公司查询中···',
        '舆情信息查询中···',
        '知识产权数据查询中···',
        '预测公司增长率···',
        '建模估值···',
        '估值结果汇总···'
      ],
      contflag: 0,
      contnumberflag: 0,
      cont: 0,
      loadTimeId: null,
      flowTitle: ''
    }
  },
  methods: {
    run() {
    //   console.log('inter1234')
      if (this.contflag > this.textflag.length - 1) {
        this.contflag = 0
      } else if (this.contnumberflag > 0) {
        this.contnumberflag = 0
        this.contflag++
      }

      if (this.cont > this.textflag[this.contflag].length) {
        this.contnumberflag++
        this.cont = 0
      }
    //   console.log(this.contflag, this.textflag, this.contnumberflag, this.cont)
      this.flowTitle = this.textflag[this.contflag].substring(0, this.cont++)
    }
  },
  mounted() {
    this.loadTimeId = setInterval(this.run, 300)
  },
  beforeDestroy() {
    clearInterval(this.loadTimeId)
    this.loadTimeId = null
  }
}

</script>

<style lang='less'>
.downloadLoadingWrapper{
    position: absolute;
.downloadLoading{
    position:fixed;
    left:0;
    top:0;
    right:0;
    bottom:0;
    background: rgba(0,0,0,.7);
}
.downloadLoadingWrapper{
    width:6.3rem;
    height:3.22rem;
    background-color:#fff;
    opacity:1;
    border-radius:0.3rem;
    margin: -1.61rem -3.15rem;
    position:absolute;
    top:50%;
    left:50%;
}
.downloadimgWrapper{
    width:1.36rem;
    height:auto;
    margin:0 auto;
}
.downloadImg{
    width:100%;
    height:auto;
}
.subSucess{
   text-align:center;
   font-size:0.3rem;
}
.sysValuting{
   text-align:center;
   font-size:0.26rem;
   color:#ccc;
   padding-top:0.1rem;
}
.dataSerching{
    font-size: 0.24rem;
    font-family: Microsoft YaHei, Microsoft YaHei-Regular;
    font-weight: 400;
    text-align: center;
    color: #5883ff;
    line-height:0.4rem;
    letter-spacing: 0.01rem;
    margin-top:0.3rem;
}
}
</style>



// WEBPACK FOOTER //
// src/components/getReportLoading/reportLoading.vue